module.exports = __webpack_public_path__ + "static/media/6.9e53fcd6.jpg";